import React from 'react';
import UserManagement from '../UserManagement';

const UsersSection = () => {
  return <UserManagement />;
};

export default UsersSection;
